import { ACTU_DEL, ACTU_DETAILS, ACTU_LIKE, ACTU_LIST, ACTU_SAVE, ACTU_VIEW } from "../actions/action-types";
import { initalState, initialStateDatasArray, initialSTateDatasData, initialStateNext } from "../helpers";

// Ajouter / Modifier une actu
export function SetActusReducer(state = initalState, action) {
    switch (action.type) {
        case ACTU_SAVE:
            return {
                alert: action.payload.alert
            }
        default:
            return {
                alert: state.alert
            };
    }
}

// Supprimer une actu
export function DelActuReducer(state = initialStateNext, action) {
    switch (action.type) {
        case ACTU_DEL:
            return {
                alert: action.payload.alert,
                isNext: action.payload.isNext
            }
        default:
            return state;
    }
}

// Détails d'une actu
export function DetailsActuReducer(state = initialSTateDatasData, action) {
    switch (action.type) {
        case ACTU_DETAILS:
            return {
                alert: action.payload.alert,
                datas: action.payload.datas
            }
        default:
            return state;
    }
}

// Lister les actus
export function ListActuReducer(state = initialStateDatasArray, action) {
    switch (action.type) {
        case ACTU_LIST:
            return {
                alert: action.payload.alert,
                datas: action.payload.datas
            }
        default:
            return state;
    }
}

// Mettre un like à une actu
export function LikeActuReducer(state = initialStateNext, action) {
    switch (action.type) {
        case ACTU_LIKE:
            return {
                alert: action.payload.alert,
                isNext: action.payload.isNext
            }
        default:
            return state;
    }
}

// Mettre à jour le nombre de vue
export function ViewActuReducer(state = initialStateNext, action) {
    switch (action.type) {
        case ACTU_VIEW:
            return {
                alert: action.payload.alert,
                isNext: action.payload.isNext
            }
        default:
            return state;
    }
}